import { FC, ReactNode } from "react";
import { Anchor } from "@/components/Header/Anchor/Anchor";
import { Heading } from "@/components/Html/Heading";
import { Section } from "@/components/Html/Section";
import { testIds } from "@/test/testId/testIds";
import { ContactLink } from "../ContactLink/ContactLink";

interface Props {
  heading: ReactNode;
  description: ReactNode;
  button: string;
}

export const Top: FC<Props> = ({ heading, description }) => {
  return (
    <Section className="mt-[62px] bg-radial-gradient md:mt-[76px]">
      <Section className="kdot-container mx-auto !py-24">
        <Anchor id="top" />
        <Heading>
          <p className="text-[45px] md:text-[57px]">{heading}</p>
        </Heading>
        <p className="my-4 text-[22px]">{description}</p>
        <ContactLink testId={testIds.serivce.top.contactLink} />
      </Section>
    </Section>
  );
};
